import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ChevronDownIcon } from '../../../../../shared/icons/chevron-down.svg';
import { ApprovalRequestActions } from './requestReview/RequestInternalApprovalModalConstants';
import HandleInternalApprovalActionsModal from './requestReview/HandleInternalApprovalActionsModal';
import './mobile-approval-actions-dropdown.scss';

interface MobileApprovalActionsDropdownProps {
  documentId: string;
  dealId: string;
  teamId: string;
  reviewId: string;
  handleSaveDocument?: () => Promise<void>;
}

export const MobileApprovalActionsDropdown: React.FC<MobileApprovalActionsDropdownProps> = ({
  documentId,
  dealId,
  teamId,
  reviewId,
  handleSaveDocument,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState<ApprovalRequestActions | null>(null);

  const handleActionSelect = (action: ApprovalRequestActions) => {
    setSelectedAction(action);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedAction(null);
  };

  return (
    <>
      <Dropdown className="mobile-approval-actions-dropdown">
        <Dropdown.Toggle
          variant="outline-primary"
          className="mobile-approval-actions-dropdown__toggle"
          id="mobile-approval-actions-dropdown"
        >
          <FormattedMessage id="mobile.approval.actions" defaultMessage="Actions" />
          <ChevronDownIcon className="mobile-approval-actions-dropdown__chevron" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="mobile-approval-actions-dropdown__menu">
          <Dropdown.Item
            className="mobile-approval-actions-dropdown__item mobile-approval-actions-dropdown__item--approve"
            onClick={() => handleActionSelect(ApprovalRequestActions.APPROVE)}
          >
            <FormattedMessage id="mobile.approval.approve" defaultMessage="Approve Document" />
          </Dropdown.Item>

          <Dropdown.Item
            className="mobile-approval-actions-dropdown__item mobile-approval-actions-dropdown__item--reject"
            onClick={() => handleActionSelect(ApprovalRequestActions.REJECT)}
          >
            <FormattedMessage id="mobile.approval.reject" defaultMessage="Reject Document" />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {showModal && selectedAction && (
        <HandleInternalApprovalActionsModal
          show={showModal}
          onHide={handleModalClose}
          documentId={documentId}
          requestApprovalAction={selectedAction}
          dealId={dealId}
          teamId={teamId}
          reviewId={reviewId}
          handleSaveDocument={handleSaveDocument}
        />
      )}
    </>
  );
};
